import { ZodError } from 'zod';

export function getZodErrorFromResponse(str: string): false | ZodError<unknown> {
    try {
        const json = JSON.parse(str);
        if (
            typeof json === 'object' &&
            json != null &&
            'name' in json &&
            typeof json.name === 'string' &&
            json.name === 'ZodError'
        ) {
            return new ZodError([...json.issues]);
        }
        return false;
    } catch (error) {
        return false;
    }
}
